import type {InviteApiModel} from '../../../api/invite';
import type {Entity} from '../../../api/types';

import {getEntityTypeById} from '../getEntityType';

export function isInvite(entity: Entity): entity is InviteApiModel {
  const type = getEntityTypeById(entity._id);

  return type === 'invite';
}
